/* global localStorage */

import axios from 'axios'
import authentication from '@/utilities/authentication'

const API_URL = process.env.API_URL

let axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
})

axiosInstance.interceptors.request.use(
  config => {
    config.headers['X-User-Email'] = authentication.username()
    config.headers['X-User-Token'] = authentication.token()
    return config
  },
  error => Promise.reject(error)
)

export default axiosInstance



// WEBPACK FOOTER //
// ./src/axios.js